export const GAME_LAUNCH_TYPE = {
    CASINO: 'Casino',
    DEFAULT: 'Default'
};

export enum LAUNCH_STAGE {
    closed = 'closed',
    start = 'start',
    verifications = 'verifications',
    openGame = 'openGame'
}
